module.exports = __webpack_public_path__ + "static/2.1_543x800_Mobile_Hero_2X-27e7feecc12a7157f584bd079a3cc00a.png";